module.exports = __webpack_public_path__ + "media/assets/images/arrow-1ee4c3ee10a89d4ebe3782b2ff0d9eea.svg";